import React from "react";
import { NavLink, Route, Routes, useNavigate } from "react-router-dom";
import {
  LayoutGrid, KeyRound, BarChart3, CreditCard, Coins, Settings2, Package,
} from "lucide-react";
import Header from "@/components/Header";
import { useLang } from "@/lib/i18n";
import DashOverview from "@/pages/dashboard/DashOverview";
import DashSubscriptions from "@/pages/dashboard/DashSubscriptions";
import DashApiKeys from "@/pages/dashboard/DashApiKeys";
import DashUsage from "@/pages/dashboard/DashUsage";
import DashBilling from "@/pages/dashboard/DashBilling";
import DashCredits from "@/pages/dashboard/DashCredits";
import DashSettings from "@/pages/dashboard/DashSettings";

export default function DashboardPage() {
  const { t } = useLang();
  const items = [
    { to: "", icon: LayoutGrid, label: t("dash.overview"), end: true, id: "overview" },
    { to: "subscriptions", icon: Package, label: t("dash.subs"), id: "subs" },
    { to: "api-keys", icon: KeyRound, label: t("dash.keys"), id: "keys" },
    { to: "usage", icon: BarChart3, label: t("dash.usage"), id: "usage" },
    { to: "billing", icon: CreditCard, label: t("dash.billing"), id: "billing" },
    { to: "credits", icon: Coins, label: t("dash.credits"), id: "credits" },
    { to: "settings", icon: Settings2, label: t("dash.settings"), id: "settings" },
  ];
  return (
    <div>
      <Header />
      <div className="max-w-7xl mx-auto px-6 py-8 grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-8">
        <aside className="lp-card p-4 h-fit sticky top-24">
          <div className="text-xs uppercase tracking-widest text-white/40 px-2 pb-3">Account</div>
          {items.map((it) => (
            <NavLink
              key={it.id}
              to={`/dashboard/${it.to}`}
              end={it.end}
              className={({ isActive }) => `lp-sidebar-link ${isActive ? "active" : ""}`}
              data-testid={`dash-nav-${it.id}`}
            >
              <it.icon className="w-4 h-4" /> {it.label}
            </NavLink>
          ))}
        </aside>

        <main>
          <Routes>
            <Route index element={<DashOverview />} />
            <Route path="subscriptions" element={<DashSubscriptions />} />
            <Route path="api-keys" element={<DashApiKeys />} />
            <Route path="usage" element={<DashUsage />} />
            <Route path="billing" element={<DashBilling />} />
            <Route path="credits" element={<DashCredits />} />
            <Route path="settings" element={<DashSettings />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
